<template>
    <div>
        <app-kpiform v-if="kpi"
        v-bind:parentObject="{
            kpi: this.kpi,
            pmkpiexercisestatus: this.pmkpiexercisestatus
        }"
        />
    </div>
</template>

<script>

import KPIForm from '../../sscomponents/performance/ProgressForm.vue';

export default {

    components: {
        'app-kpiform': KPIForm,
    },

    data() {
        return {
            kpi: this.$route.params.kpi, 
            pmkpiexercisestatus: this.$route.params.pmkpiexercisestatus
        }

        
    },

    methods: {
    },

    mounted() {
        console.log("KPIProgress:", this.kpi);
    }
}

</script>

<style scoped>

</style>